
    const data = {"name":"src/core/icons/lock-open-variant","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M18 1c-2.76 0-5 2.24-5 5v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12c1.11 0 2-.89 2-2V10a2 2 0 0 0-2-2h-1V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2h2V6c0-2.76-2.24-5-5-5m-8 12a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            